export const LIST_STATUS = ['arealizar', 'enproceso', 'requiereatencion', 'completado']